import { FC, ReactNode } from 'react';
import { AnimatedShape, Box, useThemeValue } from '@altermaind/web/ui';

export type PaginatedCardsProps = {
  pageSize: number;
  Skeleton?: ReactNode;
};

export const PaginatedCardsSkeleton: FC<PaginatedCardsProps> = ({ pageSize, Skeleton }) => {
  const xlSpace = useThemeValue('space', 'xl');
  return (
    <Box>
      <Box style={{ gap: xlSpace }} display='grid' gridTemplateColumns={`repeat(${pageSize}, 1fr)`}>
        {new Array(pageSize).fill(null).map(() => Skeleton || null)}
      </Box>
      <Box display='flex' justifyContent='end' alignItems='center' mt='s'>
        <Box mt='s'>
          <AnimatedShape height={30} width='20%' variant='semiRound' />
        </Box>
        <AnimatedShape height={30} width='40%' variant='semiRound' />
      </Box>
    </Box>
  );
};
